import React, {useEffect , useState} from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import axios from "axios";
import { API_URL } from "../../constent";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  BackTo,
  PreviewCard,
  ReactDataTable,
} from "../../components/Component";

var userData = JSON.parse(localStorage.getItem('userData'));
var role = userData?.[0]?.role;

const dataTableColumns = [
    {
      name: "Name",
      selector: (row) => row.category_name,
      sortable: true,
    },
    {
      name: "Created",
      selector: (row) => row.created,
      sortable: false,
    },
    {
        name: "Actions",
        cell: (row) => (
          <div>
            {
              role === 1 &&(
                  <button
                    onClick={() => handleDelete(row.id)}
                    style={{
                      backgroundColor: "#f44336",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                    }}
                  >
                    Delete
                  </button>
              )
            }
            
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
  ];

const handleDelete = (id) => {
const confirmDelete = window.confirm("Are you sure you want to delete this item?");
if (confirmDelete) {
    axios.get(`${API_URL}deletcategory/${id}`).then((result)=>
    {
        console.log(result.data);
        window.location.reload();
    })
}
};

const CategoryList = () => {

const [policydata , SetProduct] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(()=>{
        axios.post( `${API_URL}getcategory`).then((result)=>
        {
            console.log(result.data);
            SetProduct(result.data);
            setLoading(false);
        }) 
 },[])

 if (loading) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  return (
    <React.Fragment>
      <Head title="Category" />
      <Content page="component">
        
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <BlockTitle tag="h4">Category List <Link to="/add-category" className="btn btn-info" style={{"float":"right"}}>Add Category</Link></BlockTitle>
            </BlockHeadContent>
          </BlockHead>

          <PreviewCard>
            <ReactDataTable data={policydata} columns={dataTableColumns} expandableRows pagination />
          </PreviewCard>
        </Block>

      </Content>
    </React.Fragment>
  );
};
export default CategoryList;
